var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['core', 'component/range-selector/storage'], function(core, RangeStorage) {
  var RangeCoreStorage;
  return RangeCoreStorage = (function(_super) {

    __extends(RangeCoreStorage, _super);

    function RangeCoreStorage() {
      RangeCoreStorage.__super__.constructor.apply(this, arguments);
    }

    RangeCoreStorage.prototype.getEarliestDate = function() {
      return core.getEarliestTransactionTime();
    };

    RangeCoreStorage.prototype.saveInterval = function(interval) {
      return core.saveCurrentInterval(interval);
    };

    RangeCoreStorage.prototype.loadInterval = function() {
      return core.loadCurrentInterval();
    };

    return RangeCoreStorage;

  })(RangeStorage);
});
